import type { LstWithdrawalReader } from './shared'

/**
 * Placeholder reader for protocols that can't be enumerated
 * on-chain. Used for:
 *  - **eventsOnly** — mETH, pufETH, osETH require off-chain event
 *    indexing to discover request IDs. The orchestrator could be
 *    extended to accept an event-derived list of (user, requestId)
 *    pairs as input; until then these return [].
 *  - **noQueue** — rETH (instant burn against deposit-pool buffer)
 *    and cbETH (off-chain Coinbase redemption). No queue to
 *    enumerate.
 *  - **unverified** — kHYPE, beHYPE, wstHYPE, swETH. Function
 *    selectors not yet pinned against the deployed contracts.
 *
 * Returning [] is correct behavior: the user simply has no
 * fetched-via-this-API pending withdrawals for this LST, even if
 * they have one in reality. UI should surface the limitation
 * separately (e.g. link to the protocol's official UI).
 */
export const readerEmpty: LstWithdrawalReader = {
  fetch: async () => [],
}
